<template>
  <div>
    <header-ton></header-ton>
    <div class="chapter" v-loading="loading" element-loading-text="数据加载中">
      <div class="mk_conbox">
        <div class="mkcn_lf">
          <div class="navs">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/web/chapter' }">返回</el-breadcrumb-item>
              <el-breadcrumb-item>{{ chapter.subject_name }}</el-breadcrumb-item>
              <el-breadcrumb-item>{{ chapter.title }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="examTab-num">
              <em>{{ chapter.do }}</em>
              / {{ chapter.nums }}
            </div>
          </div>
          <div class="pra-left-con pra-right-font16">
            <!-- 练习模式做题-->
            <div id="questionModule" class="cross-range">
              <ul class="swiper-wrapper">
                <swiper ref="mySwiper" :options="swiperOptions">
                  <swiper-slide v-for="(item, index) in chapterData" :key="index">
                    <li class="swiper-slide">
                      <div class="subject-con bor m-question dis_fd_1 disabled">
                        <div class="subject-con dis_fd_2 dis_sb" style="background:inherit">
                          <div class="sub-content sub-conanswer">
                            <div class="sub-dotitle">
                              <em>{{ index + 1 }}.</em>
                              <i v-if="item.type == 0">[判断题]</i>
                              <i v-if="item.type == 1">[单选题]</i>
                              <i v-if="item.type == 2">[多选题]</i>
                              <i v-if="item.type == 3">[材料题]</i>
                              <i v-if="item.type == 4">[不定项选择]</i>
                              <span v-html="item.title"></span>
                            </div>

                            <dl class="sub-answer" v-if="item.type == 0">
                              <div v-if="item.user_answer">
                                <dd
                                  :class="'m-question-option' + (item.user_answer == items.key ? ' cho-this' : '') + (item.answer == items.key ? ' right-this' : ' wrong-this')"
                                  v-for="(items, idx) in item.select_list" :key="idx" :data-value="items.key">
                                  <i></i>
                                  <span>{{ items.key }}.</span>
                                  <span v-html="items.value"></span>
                                </dd>
                              </div>
                              <div v-else>
                                <dd @click="checkRadio(item, items.key, index)"
                                  :class="'m-question-option' + (item.is_view ? (item.answer == items.key ? ' right-this' : '') : '')"
                                  :data-value="items.key" v-for="(items, idx) in item.select_list" :key="idx">
                                  <i></i>
                                  <span>{{ items.key }}.</span>
                                  <span v-html="items.value"></span>
                                </dd>
                              </div>
                            </dl>

                            <dl class="sub-answer" v-if="item.type == 1">
                              <div v-if="item.user_answer">
                                <dd
                                  :class="'m-question-option' + (item.user_answer == items.key ? ' cho-this' : '') + (item.answer == items.key ? ' right-this' : ' wrong-this')"
                                  v-for="(items, idx) in item.select_list" :key="idx" :data-value="items.key">
                                  <i></i>
                                  <span>{{ items.key }}.</span>
                                  <span v-html="items.value"></span>
                                </dd>
                              </div>
                              <div v-else>
                                <dd @click="checkRadio(item, items.key, index)"
                                  :class="'m-question-option' + (item.is_view ? (item.answer == items.key ? ' right-this' : '') : '')"
                                  :data-value="items.key" v-for="(items, idx) in item.select_list" :key="idx">
                                  <i></i>
                                  <span>{{ items.key }}.</span>
                                  <span v-html="items.value"></span>
                                </dd>
                              </div>
                            </dl>

                            <dl class="sub-answer sub-answer-double" v-if="item.type == 2">
                              <div v-if="item.user_answer">
                                <dd
                                  :class="'m-question-option' + (isInArray(items.key, item.user_answer) == true ? ' cho-this' : '') + (isInArray(items.key, item.answer) == true ? ' right-this' : ' wrong-this')"
                                  :data-value="items.key" v-for="(items, idx) in item.select_list" :key="idx">
                                  <i></i>
                                  <span>{{ items.key }}.</span>
                                  <span v-html="items.value"></span>
                                </dd>
                              </div>
                              <div v-else>
                                <dd @click="checkSelected(index, idx, items.isCorrect)"
                                  :class="'m-question-option' + (items.isCorrect == 1 ? ' cho-this' : '')"
                                  :data-value="items.key" v-for="(items, idx) in item.select_list" :key="idx">
                                  <i></i>
                                  <span>{{ items.key }}.</span>
                                  <span v-html="items.value"></span>
                                </dd>
                              </div>
                              <a @click="confirmSelected(item, index)" class="question-option-ok ck-da">确定</a>
                            </dl>

                            <dl class="sub-answer sub-answer-double"
                              v-if="item.type == 3 && item.user_answer_right == -1">
                              <div class="text">
                                <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="answer">
                                </el-input>
                              </div>
                              <div class="btns_sub" @click="submitArea(item, index)">提交答案</div>
                            </dl>
                          </div>
                          <div class="qrcode">
                            <img src="https://www.yitku.com/home/images/ytk_mini.png" />
                            <div class="txt">手机使用更便捷</div>
                          </div>
                        </div>

                        <div class="m__answerLine refer-answer dis_jcsb clearfix" v-if="item.is_view && item.type != 3">

                          <div v-if="item.is_view">
                            <div class="sub-answer-tips right" v-if="item.user_answer_right">
                              <i></i>回答正确
                            </div>
                            <div class="sub-answer-tips wrong" v-else>
                              <i></i>回答错误
                            </div>
                          </div>
                          <div class="reck">
                            正确答案：
                            <em class="right">{{ item.answer }}</em>
                            我的答案：
                            <em class="right" v-if="item.user_answer && item.user_answer_right == 1">{{ item.user_answer
                            }}</em>
                            <em class="wrong" v-else-if="item.user_answer && item.user_answer_right == 0">{{
                              item.user_answer }}</em>
                            <em class="wrong" v-else>未作答</em>
                          </div>
                          <ul>
                            <li class="nobro">
                              <a href="javascript:void(0)" data-examid="4349" class="btn__scbt scbt">
                                <i></i>收藏本题
                              </a>
                            </li>
                          </ul>
                          <a href="javascript:;" class="ask-btn-new">
                            <i></i>提问
                          </a>
                        </div>

                        <div class="m__analyse detail-intro" v-if="item.is_view">
                          <div class="solution">
                            <ul>
                              <li v-if="item.desc">
                                <span class="s-zsd">
                                  <i></i>考查考点：
                                </span>
                                <div class="so-text" v-html="item.desc"></div>
                              </li>
                              <li class="da-list" v-if="item.content">
                                <span class="s-jx">
                                  <i></i>解题思路：
                                </span>
                                <div class="so-timu">
                                  <div class="wenzi" v-html="item.content"></div>
                                </div>
                              </li>
                              <li v-if="item.testing">
                                <span class="s-pg">
                                  <i></i>老师提醒：
                                </span>
                                <div class="so-text" v-html="item.testing"></div>
                              </li>
                              <li v-if="item.type == 3 && item.user_answer != -1">
                                <span class="s-zsd">
                                  <i></i>我的答案：
                                </span>
                                <div class="so-text" v-html="item.user_answer"></div>
                              </li>
                              <li v-if="item.answer && item.type == 3">
                                <span class="s-zsd">
                                  <i></i>参考答案：
                                </span>
                                <div class="so-text" v-html="item.answer"></div>
                              </li>
                              <li class="da-list" v-if="item.type != 3">
                                <span class="s-stnd">
                                  <i></i>试题难度：
                                </span>
                                <div class="so-star">
                                  <b style="width:60%;"></b>
                                </div>本题共被作答
                                <em class="wrong">{{ item.total }}</em>次&nbsp;&nbsp;
                                正确率
                                <em class="wrong">{{ item.rang }}%</em>
                              </li>
                            </ul>
                          </div>
                          <div class="detail-more">
                            <a href="javascript:;" @click="showQuestion(1)" class="dy_div btn__addError">
                              <i></i>
                              试题答疑({{ item.common.length }})
                              <span></span>
                            </a>
                          </div>
                        </div>

                        <div class="m__error notes-content" v-if="isShowQuestion == true">
                          <div class="m__errorList">
                            <!--全部答疑-->
                            <div class="notes-difficu">
                              <div class="huifu-textare">
                                <el-input type="textarea" :rows="5" placeholder="你可以向我们的老师进行提问？"
                                  v-model="textarea"></el-input>
                                <div class="hf-limited">
                                  <span>限300字</span>
                                  <span
                                    style="padding-left: 10px;font-size:14px;font-weight:bold;color:#333">为避免浪费您的答疑次数，请仔细阅读</span>
                                  <a class="askgz" href="javascript:;"
                                    style="font-size:14px;font-weight:bold;color:red">答疑规范</a>
                                  <button @click="saveNote(item)" class="savanote" data-examid="4349">保存</button>
                                </div>
                              </div>
                            </div>
                            <div class="J_ShortComment">
                              <div class="comment-dy" v-for="(i, n) in item.common" :key="n">
                                <span class="common-avatar">
                                  <img :src="i.header" />
                                </span>
                                <div class="comment-block">
                                  <p class="comment-user">
                                    <span class="common-username">{{ i.nickname }}</span>
                                    <span class="comment-time">{{ i.created_at }}</span>
                                    <span class="comment-source">来自其他</span>
                                  </p>
                                  <div class="comment-content">{{ i.content }}</div>
                                </div>

                                <div class="reply-block" v-if="i.replay">
                                  <div class="reply-content">
                                    <i class="reply-icon">答</i>
                                    <div class="replyask-box">
                                      <span class="reply-user">助教回复：</span>
                                      <br />
                                      {{ i.replay }}
                                      <br />感谢您的支持！
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="btn__hideError vip-subject-pack">
                            <a href="javascript:;" @click="showQuestion(0)" class="sq-error">
                              收起答疑
                              <i></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </li>
                  </swiper-slide>
                </swiper>
              </ul>
            </div>
            <!-- 题目切换栏 -->
            <div id="m__bottomBtnLine" class="subbottom-con">
              <div class="subbottom">
                <ul class="bor">
                  <li class="btn__prev pre swiper-button-prev">
                    <a href="javascript:;">
                      <i></i>上一题
                    </a>
                  </li>
                  <li @click="showDesc" class="btn__analyse ckdan ckzt">
                    <a href="javascript:;">
                      <i></i>查看答案
                    </a>
                  </li>
                  <li class="btn__next next swiper-button-next">
                    <a href="javascript:;">
                      下一题
                      <i></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="mkcn_rt">
          <div class="mkks_rtfo">
            <div class="pra-right-con">
              <div class="study-tiku-vip m-b-20">
                <div class="vip-info-wrapper d-flex align-items-center">
                  <div class="flex-1 vip-info">
                    <div class="vip-info-name">{{ nickname }}</div>
                    <div class="vip-no-desc" v-if="vip.vip_status == 0">您还不是会员</div>
                    <div class="vip-no-desc" v-if="vip.vip_status == 2">{{ vip.vip_etime }}(已过期)</div>
                    <div class="vip-no-desc" v-if="vip.vip_status == 1">{{ vip.vip_etime }}到期</div>
                  </div>
                  <button v-if="vip.vip_status == 2" class="btn vip-buy-no">续费题库会员</button>
                  <button v-if="vip.vip_status == 0" class="btn vip-buy-no">开通题库会员</button>
                </div>
                <div class="vip-assets">
                  <div class="vip-assets-desc m-b-6">
                    开通题库付费会员尊享
                    <span class="f-w-bold" style="color: rgb(245, 118, 34);">18+特权：</span>
                  </div>
                  <div>
                    <div class="vip-assets-list">
                      <div class="vip-asset">
                        <img
                          src="https://file.233.com/ess-files/release/ess-open-web/fiex/openfiles/2023/3/20/A1D95B6377404570AC164FC029C7E9A8.png"
                          width="24px" alt />
                        <span class="m-l-8">章节练习</span>
                      </div>
                      <div class="vip-asset">
                        <img
                          src="https://file.233.com/ess-files/release/ess-open-web/fiex/openfiles/2023/3/20/440CE8B76ED24B2098979E33C731DC09.png"
                          width="24px" alt />
                        <span class="m-l-8">模拟题</span>
                      </div>
                      <div class="vip-asset">
                        <img
                          src="https://file.233.com/ess-files/ess-open-web/fiex/openfiles/2023/3/20/0B830307EA5B4173BB1674290E51ACE2.png"
                          width="24px" alt />
                        <span class="m-l-8">历年真题</span>
                      </div>
                      <div class="vip-asset">
                        <img
                          src="https://file.233.com/ess-files/release/ess-open-web/fiex/openfiles/2023/3/20/82B40B5133704B04A1E03F9F471C146E.png"
                          width="24px" alt />
                        <span class="m-l-8">每日一练</span>
                      </div>
                      <div class="vip-asset">
                        <img
                          src="https://file.233.com/ess-files/release/ess-open-web/fiex/openfiles/2023/3/20/9012613AADB94222B08A394F2D66BD1F.png"
                          width="24px" alt />
                        <span class="m-l-8">全真机考</span>
                      </div>
                      <div class="vip-asset">
                        <img
                          src="https://file.233.com/ess-files/release/ess-open-web/fiex/openfiles/2023/3/20/DB164BE8B65D454F9576D877660BB424.png"
                          width="24px" alt />
                        <span class="m-l-8">文字解析</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <!---->
                  </div>
                  <div>
                    <!---->
                  </div>
                  <!---->
                  <i class="assets-next"></i>
                </div>
              </div>

              <div id="m__rightPart" class="pra-right-con-sub"
                style="z-index: 99; position: static; top: auto; bottom: auto; left: auto;">
                <div class="time-card bor" style="margin-top: 0;">
                  <!--答题卡区域-->
                  <div class="rightArea-answer yindao clear">
                    <div id="answerCard">
                      <div class="hd clearfix">
                        <span class="title f-fl">答题卡</span>
                        <a @click="reDo()" href="javascript:;" class="btn__delhistoy del-del">
                          <i></i>
                        </a>
                      </div>
                      <div class="bd clear">
                        <dl class="panel-item">
                          <dt>判断题</dt>
                          <em>
                            <dd class="panel-order">
                              <div v-for="(item, index) in chapterData" :key="index">
                                <a v-if="item.type == 0" @click="changeChapter(index)"
                                  :class="'e__answerCard page-card-item' + (item.user_answer_right == 1 ? ' right' : '') + (item.user_answer_right == 0 ? ' error' : '')">{{
                                    index + 1 }}</a>
                              </div>
                            </dd>
                          </em>
                        </dl>
                        <dl class="panel-item">
                          <dt>单选题</dt>
                          <em>
                            <dd class="panel-order">
                              <div v-for="(item, index) in chapterData" :key="index">
                                <a v-if="item.type == 1" @click="changeChapter(index)"
                                  :class="'e__answerCard page-card-item' + (item.user_answer_right == 1 ? ' right' : '') + (item.user_answer_right == 0 ? ' error' : '')">{{
                                    index + 1 }}</a>
                              </div>
                            </dd>
                          </em>
                        </dl>
                        <dl class="panel-item">
                          <dt>多选题</dt>
                          <em>
                            <dd class="panel-order">
                              <div v-for="(item, index) in chapterData" :key="index">
                                <a v-if="item.type == 2" @click="changeChapter(index)"
                                  :class="'e__answerCard page-card-item' + (item.user_answer_right == 1 ? ' right' : '') + (item.user_answer_right == 0 ? (isCkArray(item.user_answer, item.answer) == true ? ' part' : ' error') : '')">{{
                                    index + 1 }}</a>
                              </div>
                            </dd>
                          </em>
                        </dl>
                        <dl class="panel-item">
                          <dt>材料题</dt>
                          <em>
                            <dd class="panel-order">
                              <div v-for="(item, index) in chapterData" :key="index">
                                <a v-if="item.type == 3" @click="changeChapter(index)"
                                  :class="'e__answerCard page-card-item' + (item.user_answer_right == 1 ? ' right' : '') + (item.user_answer_right == 0 ? (isCkArray(item.user_answer, item.answer) == true ? ' part' : ' error') : '')">{{
                                    index + 1 }}</a>
                              </div>
                            </dd>
                          </em>
                        </dl>
                      </div>
                    </div>
                    <div class="panel-order-notice status-items">
                      <i class="a error"></i>
                      <em class="error-em">错误</em>
                      <i class="a part">
                        <span></span>
                      </i>
                      <em class="error-em">不全对</em>
                      <i class="a right"></i>
                      <em class="error-em">正确</em>
                      <i class="a normal"></i>
                      <em class="error-em">未做</em>
                    </div>
                    <div class="ft">
                      <input type="hidden" value="78" id="id" />
                      <input type="hidden" value="0" id="type" />
                    </div>
                  </div>
                  <!--答题卡区域 end-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
import BuyVipBox from "@/components/BuyVipBox";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";

export default {
  components: {
    HeaderTon,
    BooterTon,
    BuyVipBox,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      nickname: "",
      textarea: "",
      loading: true,
      showAnswer: true,
      showVip: false,
      answer: "",
      chapter_id: 0,
      selected: 0,
      chapter: [],
      vip: [],
      isShowQuestion: false,
      current: 0,
      chapterData: [],
      questionList: [],
      swiperOptions: {
        initialSlide: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: () => {
            console.log(this.$refs.mySwiper.$swiper.realIndex);
            this.current = this.$refs.mySwiper.$swiper.realIndex;
            console.log(this.chapterData[this.current]["user_answer_right"]);
            if (this.chapterData[this.current]["user_answer_right"] == -1) {
              this.chapterData[this.current]["is_view"] = 0;
            }
            this.isShowQuestion = false;
          },
        },
      },
    };
  },

  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.chapter_id) {
      that.chapter_id = query.chapter_id;
      this.getList();
    }
    this.nickname = sessionStorage.getItem("access-nick");
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.$swiper;
    // },
  },
  methods: {
    //判断是否输入文字
    saveNote(item) {
      let that = this;
      if (this.textarea == "") {
        this.$message.error("请输入提问文字！");
        return false;
      }
      let formData = {};
      formData.column_id = item.column_id;
      formData.subject_id = item.subject_id;
      formData.type = 0;
      formData.question_id = item.id;
      formData.content = this.textarea;
      formData.pics = "";
      that.axios.post("/setSquare", formData).then((res) => {
        if (res) {
          that.textarea = "";
          that.$message.success("提交成功，请耐心等待老师回复！");
        }
      });
    },

    showQuestion(type) {
      if (type == 1) {
        this.isShowQuestion = true;
      } else {
        this.isShowQuestion = false;
      }
    },

    submitArea(item, idx) {
      let that = this;
      console.log(this.answer);
      if (this.answer == '') {
        that.$message.warning("请输入您的答案后再提交！");
        return false;
      }
      let formData = {};
      formData.answer = this.answer; //用户答案
      formData.examid = item.id; //试题ID
      formData.id = that.chapter.id; //章节ID
      formData.lening = 0; //0练习 1提交试卷 2考试保存
      formData.status = 0; //0错误 1正确
      formData.type = 0; //0  章节 1真题 2模拟 3密卷 4解密 5每日一练 6千题训练
      that.axios.post("/setExerciseRecord", formData).then((res) => {
        if (res) {
          that.chapterData[idx]["is_view"] = 1;
          that.chapterData[idx]["user_answer"] = that.answer;
          that.chapterData[idx]["user_answer_right"] = 0;
          that.chapter.do = that.chapter.do + 1;
        }
      });
    },

    //判断是否在数组中存在
    isInArray(key, ary) {
      let array = ary.split("");
      if (array.indexOf(key) != -1) {
        return true;
      } else {
        return false;
      }
    },

    //判断是否在数组中存在(key用户答案，ary试题答案)
    isCkArray(key, ary) {
      let array = ary.split("");
      let keys = key.split("");
      let status = true;
      console.log(keys);
      keys.forEach((element) => {
        console.log(element);
        if (array.indexOf(element) == -1) {
          status = false;
        }
      });
      return status;
    },

    changeChapter(idx) {
      console.log(idx);
      this.$refs.mySwiper.$swiper.slideTo(idx);
    },

    //获取一级分类
    getList() {
      let that = this;
      let formData = {};
      formData.chapter_id = that.chapter_id;
      that.axios.post("/getChapterQuestion", formData).then((res) => {
        if (res) {
          that.chapter = res.data;
          that.chapterData = res.data.lists;
          that.vip = res.data.vip;
          //that.swiperOptions.initialSlide = res.data.last_id;
          that.$refs.mySwiper.$swiper.slideTo(res.data.last_id);
          that.loading = false;
        }
      });
    },

    //单选题
    checkRadio(item, answer, idx) {
      let that = this;
      let formData = {};
      formData.answer = answer; //用户答案
      formData.examid = item.id; //试题ID
      formData.id = that.chapter.id; //章节ID
      formData.lening = 0; //0练习 1提交试卷 2考试保存
      formData.status = answer == item.answer ? 1 : 0; //0错误 1正确
      formData.type = 0; //0  章节 1真题 2模拟 3密卷 4解密 5每日一练 6千题训练
      that.axios.post("/setExerciseRecord", formData).then((res) => {
        if (res) {
          that.chapterData[idx]["is_view"] = 1;
          that.chapterData[idx]["user_answer"] = answer;
          that.chapterData[idx]["user_answer_right"] =
            answer == item.answer ? 1 : 0;
          that.chapter.do = that.chapter.do + 1;
        }
      });
    },

    //多选题（选择）
    checkSelected(index, idx, correct) {
      console.log(this.chapterData[index]["select_list"][idx]);
      if (correct == 1) {
        this.chapterData[index]["select_list"][idx]["isCorrect"] = 0;
      } else {
        this.chapterData[index]["select_list"][idx]["isCorrect"] = 1;
      }
    },

    //多选题（提交）
    confirmSelected(item, idx) {
      console.log(item);
      let that = this;
      let formData = {};
      let answer = "";
      item.select_list.forEach((element) => {
        if (element.isCorrect == 1) {
          answer += element.key;
        }
      });

      if (answer == "") {
        that.$message({
          type: "error",
          message: `操作提示: ${"请先选择试题选项"}`,
        });
        return false;
      }

      formData.answer = answer; //用户答案
      formData.examid = item.id; //试题ID
      formData.id = that.chapter.id; //章节ID
      formData.lening = 0; //0练习 1提交试卷 2考试保存
      formData.status = answer == item.answer ? 1 : 0; //0错误 1正确
      formData.type = 0; //0  章节 1真题 2模拟 3密卷 4解密 5每日一练 6千题训练
      that.axios.post("/setExerciseRecord", formData).then((res) => {
        if (res) {
          that.chapterData[idx]["is_view"] = 1;
          that.chapterData[idx]["user_answer"] = answer;
          that.chapterData[idx]["user_answer_right"] =
            answer == item.answer ? 1 : 0;
          that.chapter.do = that.chapter.do + 1;
        }
      });
    },

    //重做
    reDo() {
      let that = this;
      this.$confirm("此操作将永久删除该做题记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        let formData = {};
        formData.type = 0;
        formData.chapter_id = that.chapter.id;
        that.axios.post("/clearDoexam", formData).then((res) => {
          if (res.code == 200) {
            that.$message({
              type: "success",
              message: "删除成功!",
            });
            that.getList();
          }
        });
      });
    },

    //显示解析
    showDesc() {
      if (this.chapterData[this.current]["is_view"] == 0) {
        this.chapterData[this.current]["is_view"] = 1;
      } else {
        this.chapterData[this.current]["is_view"] = 0;
      }
    },
  },
};
</script>

<style scoped>
@import "../../../public/css/chapter.css";
@import "../../../public/css/mock.css";

.chapter {
  width: 1200px;
  margin: 85px auto 20px auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.chapter .navs {
  height: 60px;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 20px;
  border-bottom: 5px solid #ebeff1;
  border-radius: 10px 10px 0 0;
  justify-content: space-between;
}

.swiper-slide {
  height: 735px;
  overflow-y: scroll;
  display: flex;
}

.chapter .examTab-num {
  white-space: nowrap;
  font-size: 18px;
  font-weight: 900;
}

.chapter .examTab-num em {
  color: #e13b29;
  font-weight: 900;
  font-style: normal;
}

.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after {
  content: "";
}

.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  content: "";
}

.btns_sub {
  width: 120px;
  height: 44px;
  background-color: rgb(39, 112, 247);
  color: #fff;
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  margin-top: 10px;
  line-height: 44px;
  float: right;
  margin-bottom: 20px;
}
</style>